import React from 'react';
import classnames from 'classnames';

import DataTable from '@components/DataTable/DataTable';

import styles from './Status.css';

import {
  COLUMNS,
  DATA,
} from './constants/releaseNotesData';

const ReleaseNotes = () => (
  <section className={classnames(styles.statusTablesWrapper, 'black')}>
    <article>
      <DataTable
        columns={COLUMNS}
        data={DATA}
      />
    </article>
  </section>
);

export default ReleaseNotes;



// WEBPACK FOOTER //
// ./src/containers/libraryStatus/ReleaseNotes.js